// 9fbef606107a605d69c0edbcd8029e5d
import { PRODUCTLISTING_ACTION_PATTERN } from '../../../../../constants/reducer.constants';

const SET_PRODUCTS = `${PRODUCTLISTING_ACTION_PATTERN}SET_PLP_PRODUCTS`;
const FETCH_PRODUCTS = `${PRODUCTLISTING_ACTION_PATTERN}GET_PLP_PRODUCTS`;
const GET_MORE_PRODUCTS = `${PRODUCTLISTING_ACTION_PATTERN}GET_MORE_PRODUCTS`;
const SET_FIRST_PRODUCTS_PAGE = `${PRODUCTLISTING_ACTION_PATTERN}SET_FIRST_PRODUCTS_PAGE`;
const SET_PLP_LOADING_STATE = `${PRODUCTLISTING_ACTION_PATTERN}SET_PLP_LOADING_STATE`;
const SET_ADD_TO_FAVORITE = `${PRODUCTLISTING_ACTION_PATTERN}SET_ADD_TO_FAVORITE`;
const RESET_PRODUCTS = `${PRODUCTLISTING_ACTION_PATTERN}RESET_PRODUCTS`;
const SET_FILTER = `${PRODUCTLISTING_ACTION_PATTERN}SET_FILTER`;
const UNSET_PLP_BREADCRUMB = `${PRODUCTLISTING_ACTION_PATTERN}UNSET_PLP_BREADCRUMB`;
const ESSENTIAL_SHOP_STEP = `${PRODUCTLISTING_ACTION_PATTERN}ESSENTIAL_SHOP_STEP`;
const LOAD_LONG_DESCRIPTION = `${PRODUCTLISTING_ACTION_PATTERN}LOAD_LONG_DESCRIPTION`;
const SET_PLP_SCROLL_STATE = `${PRODUCTLISTING_ACTION_PATTERN}SET_PLP_SCROLL_STATE`;
const LOAD_CATEGORY_PAGE_SEO_DATA = `${PRODUCTLISTING_ACTION_PATTERN}LOAD_CATEGORY_PAGE_SEO_DATA`;
const SET_CATEGORY_PAGE_SEO_DATA = `${PRODUCTLISTING_ACTION_PATTERN}SET_CATEGORY_PAGE_SEO_DATA`;
const SET_DEVICE_TIER = `${PRODUCTLISTING_ACTION_PATTERN}SET_DEVICE_TIER`;
const SET_BOPIS_FILTER_STATE = `${PRODUCTLISTING_ACTION_PATTERN}SET_BOPIS_FILTER_STATE`;
const SET_CURRENT_CATEGORY_ID = `${PRODUCTLISTING_ACTION_PATTERN}SET_CURRENT_CATEGORY_ID`;
const SET_FIRST_PRODUCTS_PAGE_SSR = `${PRODUCTLISTING_ACTION_PATTERN}SET_FIRST_PRODUCTS_PAGE_SSR`;
const SET_IS_SEARCH_PAGE_ACTIVE = `${PRODUCTLISTING_ACTION_PATTERN}SET_IS_SEARCH_PAGE_ACTIVE`;
const RESET_PLP_PRODUCTS = `${PRODUCTLISTING_ACTION_PATTERN}RESET_PLP_PRODUCTS`;
const RESET_LOADED_PRODUCTS_PLP = `${PRODUCTLISTING_ACTION_PATTERN}RESET_LOADED_PRODUCTS_PLP`;
const APPEND_PRODUCTS = `${PRODUCTLISTING_ACTION_PATTERN}APPEND_PRODUCTS`;

export const PLP_PAGINATION_ENABLED = true;

export const PRODUCTS_PER_LOAD = 20; // TODO - change this to config value. the number of products to load on each call to BE (as the user scrolls)
export const PRODUCTS_PER_LOAD_NEW = 80;
export const DESCRIPTION_FILTER = 'auxdescription_uFilter';
export const FILTER_COLOR_SWATCH_URL = '/v1/ecom/assets/static/category/color-swatches/';

export const PROMOTIONAL_PRODUCTS_URL = 'promotional-products/';

export const routingInfoStoreView = {
  getOriginImgHostSetting: () => {
    return 'https://test4.childrensplace.com';
  },
};
export const PRODUCTS_PER_LOAD_LOWER_END_DEVICES = 10;

export const PRODUCTS_PER_HORIZONTAL_BUCKET = 8;

const PRODUCTLISTING_CONSTANTS = {
  SET_PRODUCTS,
  FETCH_PRODUCTS,
  GET_MORE_PRODUCTS,
  SET_FIRST_PRODUCTS_PAGE,
  SET_PLP_LOADING_STATE,
  RESET_PRODUCTS,
  SET_FIRST_PRODUCTS_PAGE_SSR,
  SET_ADD_TO_FAVORITE,
  SET_FILTER,
  UNSET_PLP_BREADCRUMB,
  ESSENTIAL_SHOP_STEP,
  LOAD_LONG_DESCRIPTION,
  SET_PLP_SCROLL_STATE,
  LOAD_CATEGORY_PAGE_SEO_DATA,
  SET_CATEGORY_PAGE_SEO_DATA,
  SET_DEVICE_TIER,
  SET_BOPIS_FILTER_STATE,
  SET_CURRENT_CATEGORY_ID,
  SET_IS_SEARCH_PAGE_ACTIVE,
  RESET_PLP_PRODUCTS,
  RESET_LOADED_PRODUCTS_PLP,
  APPEND_PRODUCTS,
};

export default PRODUCTLISTING_CONSTANTS;
